// extracted by mini-css-extract-plugin
export default {"card":"card__-7fd8a70b","row":"row__-7fd8a70b","group":"group__-7fd8a70b","label":"label__-7fd8a70b","fixed":"fixed__-7fd8a70b","value":"value__-7fd8a70b"};